module.exports = __webpack_public_path__ + "static/media/best-buy-small_2x.81d2ca39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/best-buy-small_2x.png
// module id = 738
// module chunks = 27